import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { icon } from './icon.vanilla.mjs';

function CheckIcon({
  className: classNameFromProps,
  ...props
}) {
  const className = classNames(icon, classNameFromProps);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-scope": "checkbox",
      "data-part": "check-icon",
      "data-checkbox-icon": "",
      className,
      width: "10",
      height: "9",
      viewBox: "0 0 10 9",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx("path", { d: "M1 4L4.11111 7L9 1", stroke: "white", strokeWidth: "2" })
    }
  );
}

export { CheckIcon };
//# sourceMappingURL=CheckIcon.mjs.map
